import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chats: [],
  userNames: [],
  currentIndex: 0,
  sendMessage: false,
  hasMore: true,
  loading: false,
  error: null,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    loadChats: (state) => {
      state.loading = true;
      state.error = null;
    },
    reset: (state) => {
      state.loading = false;
      state.error = null;
      state.chats = [];
      state.userNames = [];
      state.currentIndex = 0;
    },
    loadedChats: (state, action) => {
      state.loading = false;
      state.chats = action.payload.chats;
      state.hasMore = action.payload.hasMore;
    },
    loadedMoreChats: (state, action) => {
      state.loading = false;
      state.chats = [...state.chats, ...action.payload.chats];
      state.hasMore = action.payload.hasMore;
    },
    setChatError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSendMessage: (state, { payload }) => {
      state.sendMessage = payload;
    },
    addMessage: (state, action) => {
      const { chatId, message } = action.payload;
      const chat = state.chats.find((c) => c.id === chatId);
      if (chat) {
        chat.messages.push(message);
      }
    },
    replaceMessage: (state, action) => {
      const { chatId, tempId, newMessage } = action.payload;
      const chat = state.chats.find((c) => c.id === chatId);
      if (chat) {
        chat.messages = chat.messages.map((msg) =>
          msg.id === tempId ? { ...newMessage, sending: false } : msg
        );
      }
    },
    removeMessage: (state, action) => {
      const { chatId, tempId } = action.payload;
      const chat = state.chats.find((c) => c.id === chatId);
      if (chat) {
        chat.messages = chat.messages.filter((msg) => msg.id !== tempId);
      }
    },
    updateLastMessage: (state, action) => {
      const { chatId, message, createdAt, customer_user_id } = action.payload;

      const chatIndex = state.chats.findIndex((chat) => chat.id === chatId);
      if (chatIndex !== -1) {
        const existingIndex = state.chats[chatIndex].messages.findIndex(
          (msg) => msg.message === message && msg.sending
        );

        if (existingIndex !== -1) {
          state.chats[chatIndex].messages[existingIndex] = {
            message,
            createdAt,
            customer_user_id,
            sending: false,
          };
        } else {
          state.chats[chatIndex].messages.push({
            message,
            createdAt,
            customer_user_id,
          });
        }
      }
    },
    finalizeChatSuccess: (state, action) => {
      state.chats = state.chats.map((chat) =>
        chat.id === action.payload.chatId ? { ...chat, finalized: true } : chat
      );
    },
  },
});

export const chatActions = chatSlice.actions;
export default chatSlice.reducer;
